import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  confirmStepHeader: {
    defaultMessage: 'Confirm transfer',
    id: '6FvVSd',
    description: 'Header text for the confirm transfer step section',
  },
  confirmStepDescription: {
    defaultMessage:
      'Once created Inventory will be deducted from your origin warehouse. It will not be added to your destination warehouse until it is received.',
    id: 'bOCa10',
    description: 'Description text for the confirm transfer step',
  },
  productsToTransferHeader: {
    defaultMessage: 'Products to be transferred: {count}',
    id: 'v/QFTC',
    description: 'Header for the products to transfer section in confirm step',
  },
  originWarehouseDisplayLabel: {
    defaultMessage: 'Origin Warehouse',
    id: 'SPO4wh',
    description: 'Display label for origin warehouse in confirm step',
  },
  destinationWarehouseDisplayLabel: {
    defaultMessage: 'Destination Warehouse',
    id: 'JximIG',
    description: 'Display label for destination warehouse in confirm step',
  },
});
